export const NAO_HA_FATURAMENTOS = 'Não há faturamentos para esse período'
export const NAO_HA_FATURAMENTOS_FILIAL = 'Não há faturamentos para essa filial'
